import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import { confirmNewsletter } from "../lib/api";
import { useT } from "../i18n/I18nProvider";

export default function ConfirmEmail() {
  const { t, lp } = useT();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading");
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); return; }
    confirmNewsletter(token)
      .then((d) => { setEmail(d.email); setState(d.status === "already_confirmed" ? "already" : "success"); })
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="confirm-page">
      {state === "loading" && (<><Loader2 className="w-10 h-10 mx-auto text-slate-400 animate-spin" /><p className="mt-4 text-slate-500">{t("confirm.confirming")}</p></>)}
      {state === "success" && (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-emerald-500" />
          <h1 className="font-display text-3xl font-semibold text-slate-900 mt-6">{t("confirm.successTitle")}</h1>
          <p className="text-slate-600 mt-3"><strong>{email}</strong> — {t("confirm.successBody")}</p>
          <Link to={lp("/")} className="hej-btn-primary inline-flex mt-8" data-testid="confirm-home-btn">{t("confirm.home")}</Link>
        </>
      )}
      {state === "already" && (
        <>
          <CheckCircle2 className="w-16 h-16 mx-auto text-slate-400" />
          <h1 className="font-display text-3xl font-semibold text-slate-900 mt-6">{t("confirm.alreadyTitle")}</h1>
          <p className="text-slate-600 mt-3">{t("confirm.alreadyBody", { email })}</p>
          <Link to={lp("/")} className="hej-btn-primary inline-flex mt-8">{t("confirm.home")}</Link>
        </>
      )}
      {state === "error" && (
        <>
          <AlertCircle className="w-16 h-16 mx-auto text-[#DC143C]" />
          <h1 className="font-display text-3xl font-semibold text-slate-900 mt-6">{t("confirm.invalidTitle")}</h1>
          <p className="text-slate-600 mt-3">{t("confirm.invalidBody")}</p>
          <Link to={lp("/")} className="hej-btn-primary inline-flex mt-8">{t("confirm.home")}</Link>
        </>
      )}
    </div>
  );
}
